import { Eye, RefreshCw } from 'lucide-react';
import { useDemoCohort } from '../contexts/DemoCohortContext';
import CohortPicker from './CohortPicker';

// Board / Senior-Management demo cohort login (2026-06-16).
//
// Persistent top banner shown while the shared demo login is VIEWING a cohort
// owner. Mirrors the act-as banner's "you're viewing as X + a way out" shape,
// but the way out here is "Switch owner" → reopens the cohort picker.
//
// Renders nothing for normal owners / accountants / single-owner stakeholders.
export default function DemoViewBanner() {
  const { isDemoLogin, viewingOwnerContactId, viewingOwner, pickerOpen, openPicker } = useDemoCohort();

  if (!isDemoLogin || !viewingOwnerContactId) {
    // Still allow the switch overlay to render if it was opened (defensive).
    return pickerOpen ? <CohortPicker dismissable /> : null;
  }

  const label = viewingOwner?.full_name || viewingOwner?.primary_email || viewingOwnerContactId;

  return (
    <>
      <div className="aop-demo-banner" style={styles.banner} role="status" aria-label="Demo view-only access">
        <Eye size={16} style={{ flexShrink: 0 }} />
        <span style={styles.text}>
          <strong>Viewing as {label}</strong> — demo view-only. You can browse everything but changes aren't saved.
        </span>
        <button type="button" onClick={openPicker} style={styles.switchBtn} title="Switch to another owner">
          <RefreshCw size={13} /> Switch owner
        </button>
      </div>
      {pickerOpen && <CohortPicker dismissable />}
    </>
  );
}

const styles = {
  banner: {
    display: 'flex', alignItems: 'center', gap: '12px',
    backgroundColor: 'var(--gold-light, #fdf6e7)',
    border: '1px solid rgba(176, 125, 42, 0.4)',
    color: '#7a5a1c',
    borderRadius: '8px', padding: '10px 14px',
    fontSize: '13px', lineHeight: 1.4,
    fontWeight: 500, flexWrap: 'wrap'
    // NOTE: margins are set in index.css via .aop-demo-banner so they can be
    // responsive (clear the fixed 260px sidebar on desktop, full-width on
    // mobile). An inline `margin` here would override the class and re-break
    // the left cut-off behind the sidebar.
  },
  text: { flex: 1, minWidth: '180px' },
  switchBtn: {
    backgroundColor: '#7a5a1c', color: '#fff', border: 'none',
    borderRadius: '6px', padding: '6px 12px', fontSize: '12px', fontWeight: 600,
    cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px', flexShrink: 0
  }
};
